import { useContext } from 'react';

import './styles.scss';
import PricingGroup from '../../../../components/pricing-group';
import { PricingContext } from '../../../../providers/pricing-provider';
const ITEMS = [
  { key: 'spot', label: 'Spot' },
  { key: 'forward', label: 'Forward' },
  { key: '10P', label: '10P (%)' },
  { key: '25P', label: '25P (%)' },
  { key: 'ATMF', label: 'ATMF (%)' },
  { key: '25C', label: '25C (%)' },
  { key: '10C', label: '10C (%)' },
  { key: 'strikevol', label: 'StrikeVol (%)' },
];

const PricingData = () => {
  const { trades, getTradeResult } = useContext(PricingContext);

  const formatValue = (value: any): string => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'number') {
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 6,
      });
    }
    return String(value);
  };

  const getValue = (tradeId: string, key: string): string => {
    const result = getTradeResult(tradeId);
    return formatValue(result?.market?.display?.[key]);
  };

  return (
    <div className="pricing-data">
      <PricingGroup label={'Market data'} isClosable defaultOpen={true}>
        <div className="content-header">
          <div className="content-header-items">
            <div className="content-header-items-fixed"></div>
            {trades.map((trade) => (
              <div key={trade.id} className="content-header-items-trade">
                <span className="content-header-items-trade-label">Market</span>
                <span className="content-header-items-trade-label">Override</span>
              </div>
            ))}
            <div className="content-header-items-trade">
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div className="pricing-data-container">
          <div className="fixed-panel">
            {ITEMS.map((item) => (
              <span className="item" key={item.key}>
                {item.label}
              </span>
            ))}
          </div>

          <div className="content-panel">
            {trades.map((trade) => (
              <div key={trade.id} className="block">
                {ITEMS.map((item, index) => (
                  <div className="item-row" key={item.key}>
                    <span className="item-content">{getValue(trade.id, item.key)}</span>
                    <span className={`item-content ${index < 2 ? 'item-content-spot' : ''}`}>
                      {index < 2 ? '' : '-'}
                    </span>
                  </div>
                ))}
              </div>
            ))}
            <div className="block"></div>
          </div>
        </div>
      </PricingGroup>
    </div>
  );
};

export default PricingData;
